import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ChoferEADDto;
import { columnas } from "./columns";
const resource = resources.ChoferEAD;
export class ChoferEADList extends React.PureComponent {
    onBorrar = async (x: Entity) => {
        if (await kea.yesno("¿Borrar chofer EAD?", x.Nombre)) {
            await resource.delete(x.IdRegistro);
        }
    }

    onDeshabilitar = async (x: Entity) => {
        const mensaje = x.Deshabilitado ? "¿Habilitar este chofer de EAD?" : "¿Deshabilitar este chofer de EAD?";
        if (await kea.yesno(mensaje)) {
            var metodo = x.Deshabilitado ? resource.Habilitar : resource.Deshabilitar;
            await metodo(x.IdRegistro);
        }
    }

    items = observeResource(resource.query);
    onEdit = (x: Entity) => history.go(`./${x.IdRegistro}`);
    onAgregar = () => history.go('./new');
    onRegresar = () => history.go('../');

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Choferes EAD" onRegresar={this.onRegresar}>
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>

                <kea.Grid2 columnas={cols} cookieKey={"ChoferEADListCookieKey"} items={this.items} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/choferEAD/list/list.tsx